import { useSyncExternalStore } from "react";

/** How many 3D views are mounted: the picker offers its embedded 3D only while none is (one WebGL canvas at a time). */
let count = 0;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function acquireThreeD(): () => void {
  count++;
  emit();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    count--;
    emit();
  };
}

export const useThreeDCount = (): number =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => void listeners.delete(l);
    },
    () => count,
    () => 0,
  );
